import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { Organization } from "@/model/data/organizations/Organization";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetOrganizationsResData } from "./GetOrganizationsCommand";

const ENDPOINT = "/organizations/editOrganizationsLicenses";

export class EditOrganizationsLicensesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: any = {};

    constructor(organizations: Organization[], notes: string) {
        super();
        this.params.organizations = [];
        organizations.forEach((organization: Organization) => {
            this.params.organizations.push({
                id: organization.id,
                name: organization.name,
                folderId: organization.folderId,
                licensesData: {
                    expirationDate: organization.licensesData.expirationDate,
                    lastUpdateUTC: organization.licensesData.lastUpdateUTC,
                    licensesByModule: organization.licensesData.licensesByModule
                        .map((l) => ({ [LicenseModuleEnum[l.key]]: l.value }))
                        .reduce((acc, curr) => {
                            const key = Object.keys(curr)[0]; // Ottieni la chiave dell'oggetto corrente
                            const value = curr[key]; // Ottieni il valore dell'oggetto corrente
                            acc[key] = value; // Aggiungi la chiave e il valore all'oggetto accumulatore
                            return acc;
                        }, {}),
                },
            });
        });
        this.params.notes = notes;
    }

    public async execute(): Promise<GetOrganizationsResData> {
        var res = await this.executeCommand({ organizations: this.params.organizations, notes: this.params.notes });
        return new GetOrganizationsResData(res);
    }
}
